// extracted by mini-css-extract-plugin
module.exports = {"interstitial":"interstitial_interstitial__kypSD","em":"interstitial_em__zJIGX","items":"interstitial_items__CPNoO"};